import { render } from "./TigerMachine.vue?vue&type=template&id=3bf11098&scoped=true&ts=true"
import script from "./TigerMachine.vue?vue&type=script&lang=ts"
export * from "./TigerMachine.vue?vue&type=script&lang=ts"

import "./TigerMachine.vue?vue&type=style&index=0&id=3bf11098&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf11098"]])

export default __exports__